import styled, { css } from 'styled-components';
import { EVO_BODY_INSET, EVO_BODY_INSET_MEDIA, EVO_BODY_INSET_WIDE } from '../../OpenXModal/utils.ts';

export const StickyFooterContainer = styled.div<{ $showShadow?: boolean }>`
  width: 100%;
  /* MPH-1116: the footer follows the body's horizontal inset (24px on the desktop dialog, 16px on
     the sheet) so the CTA lines up with the content scrolling above it; the 16px vertical inset is
     the same on both (Figma 979-40540 / 979-41409). */
  padding: ${({ theme }) => theme.kallisto.space.space200} ${EVO_BODY_INSET_WIDE};
  background-color: ${({ theme }) => theme.kallisto.color.background.static.backgroundPage};

  @media ${EVO_BODY_INSET_MEDIA} {
    padding: ${({ theme }) => theme.kallisto.space.space200} ${EVO_BODY_INSET};
  }

  ${({ $showShadow, theme }) =>
    $showShadow &&
    css`
      border-top: 1px solid ${theme.kallisto.color.border.static.borderNeutral};
      box-shadow: ${theme.kallisto.shadow.mediumTopShadow};
    `}
`;
